import { ProfileUser } from '@eastcoal/api/auth/interface'
import { queryProfileUserListByRoleCodeApi } from '@eastcoal/api/auth/profile/queryProfileUserListByRoleCode'

import { RemoteSelect } from '@eastcoal/common/components/RemoteSelect'

import { RoleUserSelectProps } from './interface'

const resolveOptions = (value?: ProfileUser[]) =>
  value
    ?.filter(item => item && item.userName)
    .map(item => ({ label: item.userName, value: item?.profileId }))

const getOptionValue = (value: ProfileUser) =>
  value ? `${value.profileId}` : ''

export const RoleUserSelect = ({
  value,
  onChange,
  roleCodes,
  mode,
  disabled
}: RoleUserSelectProps) => {
  const codeStr = roleCodes ? [...roleCodes].sort().toString() : undefined

  return (
    <RemoteSelect
      allowClear
      api={queryProfileUserListByRoleCodeApi}
      disabled={disabled}
      getOptionValue={getOptionValue}
      mode={mode}
      readyRequest={!!codeStr}
      refreshDeps={[codeStr]}
      resolveOptions={resolveOptions}
      value={value}
      requestParams={{
        roleCodes
      }}
      onChange={onChange}
    />
  )
}
